// extracted by mini-css-extract-plugin
module.exports = {"base":"app-store-button_base__cCgZg","appStoreBtn":"app-store-button_appStoreBtn__JC_Lq"};